import { GlobalState } from "src/reducers";

export const selectProfileFromCache = (state: GlobalState, userId?: string) => {
    if (!userId) return;

    const profileState = state.entities.publicProfiles;
    return profileState[`p:${userId}`];
};
